var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creditCardPaymentWrapper",attrs:{"id":"credit-card-payment"}},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":true,"is-full-page":true,"loader":"bars"},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }